import { createApi, createEffect, createStore } from "effector";
import { persist } from "effector-storage/session";

import { ServiceLocationStore } from "../types";
import { serviceCheck } from "../../../shared/api";

export const defaultState: ServiceLocationStore = {
  location: undefined,
  lastCheckedPostal: undefined,
  loading: false,
};

export const $serviceLocation = createStore<ServiceLocationStore>(defaultState);

persist<ServiceLocationStore>({
  store: $serviceLocation,
  key: "booking-v4-service-location",
  def: defaultState,
});

export const serviceCheckFx = createEffect(serviceCheck);
$serviceLocation
  .on(serviceCheckFx.done, (state, response) => {
    const locations = response.result.data.locations;
    let location: ServiceLocationStore["location"];

    if (locations.length > 0) {
      location = locations.sort((a, b) =>
        a.distance.miles > b.distance.miles ? 1 : -1,
      )[0];
    }

    return {
      ...state,
      location,
      lastCheckedPostal: response.params?.postal,
    };
  })
  .on(serviceCheckFx.pending, (state, loading) => ({ ...state, loading }));

export const serviceLocationApi = createApi($serviceLocation, {
  reset: () => defaultState,
});
